import { ChangeEventHandler, useId, useMemo } from "react";

import { useListLocaleFunctionRequest } from "../request/myHealthyAdvantageApi";
import { Select } from "../UI/Select/Select";

type LocaleSelectProps = {
  label?: string;
  onChange: ChangeEventHandler<HTMLSelectElement>;
  value?: string;
  ariaLabel?: string;
  allOption?: boolean;
};

export const LocaleSelect = ({ label, onChange, value, ariaLabel, allOption }: LocaleSelectProps) => {
  const { data: localeList, isLoading, error } = useListLocaleFunctionRequest();
  const id = useId();
  const labelId = `select-${id}`;

  const selectValue = useMemo(() => {
    if (allOption) {
      return value === undefined ? "all" : value;
    }
    return value;
  }, [value, allOption]);

  return localeList && !isLoading && !error ? (
    <div className="relative w-full">
      <Select
        label={label ?? ariaLabel}
        id={labelId}
        value={selectValue}
        onChange={onChange}
        aria-label={ariaLabel ?? label}
        data-testid="locale-selector"
        placeholder="Select locale"
      >
        {allOption && <option value={"all"}>All</option>}
        {localeList?.locales &&
          localeList.locales.map(({ id, description }) => (
            <option key={id} value={id}>
              {description}
            </option>
          ))}
      </Select>
    </div>
  ) : null;
};
